import hyd from "../assets/hyderabad 1.svg"
import del from "../assets/delhi 1.svg"
import ban from "../assets/banglore 1.svg"
import kol from "../assets/kolkata 1.svg"
import pun from "../assets/pune 1.svg"
import thala from "../assets/chennai 1.svg"
import pat from "../assets/patna (1).svg"
import vij from "../assets/vijayawada (1).svg"
import mum from "../assets/mumbai 1.svg"

export const cityJson =[
    {id:1,cityName:"Hyderabad",url:hyd},
    {id:2,cityName:"Delhi",url:del},
    {id:3,cityName:"Bangalore",url:ban},
    {id:4,cityName:"Kolkata",url:kol},
    {id:5,cityName:"Pune",url:pun},
    {id:6,cityName:"Chennai",url:thala},
    {id:7,cityName:"Patna",url:pat},
    {id:8,cityName:"Vijayawada",url:vij},
    {id:9,cityName:"Mumbai",url:mum}
]